import request from '@/utils/request'

//有声小说首页 顶部
export function ad_fiction_top(data) {
    return request({
        url: '/api/ad/fiction_top',
        method: 'post',
        params: data
    })
}
// 推荐主播
export function anchor_index(data) {
    return request({
        url: '/api/anchor/index',
        method: 'post',
        params: data
    })
}
// 关注主播
export function follow_anchor_save(data) {
    return request({
        url: '/api/follow_anchor/save',
        method: 'post',
        params: data
    })
}
// 取消关注主播
export function follow_anchor_delete(data) {
    return request({
        url: '/api/follow_anchor/delete',
        method: 'post',
        params: data
    })
}
// 是否已关注主播
export function follow_anchor_check(data) {
    return request({
        url: '/api/follow_anchor/check',
        method: 'post',
        params: data
    })
}
// 本月精华
export function book_popular(data) {
    return request({
        url: '/api/book/popular',
        method: 'post',
        params: data
    })
}
// 有声小说首页 中间
export function ad_fiction_details(data) {
    return request({
        url: '/api/ad/fiction_details',
        method: 'post',
        params: data
    })
}
// 短/长 篇小说
export function book_length(data) {
    return request({
        url: '/api/book/length',
        method: 'post',
        params: data
    })
}
// 有声小说首页 下面
export function ad_fiction_home_down(data) {
    return request({
        url: '/api/ad/fiction_home_down',
        method: 'post',
        params: data
    })
}
// 有声小说主播详情 顶部(多张)
export function ad_fiction_top_details(data) {
    return request({
        url: '/api/ad/fiction_top_details',
        method: 'post',
        params: data
    })
}
//主播详情
export function anchor_details(data) {
    return request({
        url: '/api/anchor/detail',
        method: 'post',
        params: data
    })
}
//主播声音
export function anchor_voice(data) {
    return request({
        url: '/api/anchor/voice',
        method: 'post',
        params: data
    })
}
//小说主播专辑
export function anchor_special(data) {
    return request({
        url: '/api/anchor/special',
        method: 'post',
        params: data
    })
}
//小说详情
export function book_detail(data) {
    return request({
        url: '/api/book/detail',
        method: 'post',
        params: data
    })
}
//猜一猜你喜欢
export function book_recommend(data) {
    return request({
        url: '/api/book/recommend',
        method: 'post',
        params: data
    })
}
//有声小说详情 下面
export function ad_fiction_down(data) {
    return request({
        url: '/api/ad/fiction_down',
        method: 'post',
        params: data
    })
}
//上一首下一首 
export function special_chapters(data) {
    return request({
        url: '/api/anchor/special_chapters',
        method: 'post',
        params: data
    })
}
//分类 
export function book_cate(data) {
    return request({
        url: '/api/book/cate',
        method: 'post',
        params: data
    })
}
//小说列表 
export function book_index(data) {
    return request({
        url: '/api/book/index',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/vocal.js